import {
  SEASONAL_PROJECTS_LIST_LOADING,
  SEASONAL_PROJECTS_LIST_SUCCESS,
  SEASONAL_PROJECTS_LIST_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { listItemsService } from "services/listItemsService";
import { seasonalProjectsUrl } from "api/apiUrls";

export const seasonalProjectsActions = () => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: SEASONAL_PROJECTS_LIST_LOADING, payload: true });
    const response = await listItemsService(
      `${seasonalProjectsUrl}`,
      "donation=Seasonal Projects"
    );

    dispatch({ type: SEASONAL_PROJECTS_LIST_SUCCESS, payload: response.data });
  } catch (err) {
    dispatch({ type: SEASONAL_PROJECTS_LIST_FAILURE, payload: err });
  } finally {
    dispatch({ type: SEASONAL_PROJECTS_LIST_LOADING, payload: false });
  }
};
